<template>
	<StandardModal
		open
		:title="person.fullname"
		:confirmText="$t('admin_people_reactivate_button')"
		@confirm="reactivateUser"
		:confirmProps="{ loading }"
		@cancel="close"
		small
		ref="modal"
		class="reactivate-person-modal"
	>
		<div class="modal-wrapper">
			<ReactivatedUserIcon halo />
			{{ $t('admin_people_reactivate_desc') }}
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { ReactivatedUserIcon } from '@/icons'
import { patch } from '../common'
import { storage } from '@/helpers/utils'

export default {
	name: 'ReactivatePersonModal',
	components: { StandardModal, ReactivatedUserIcon },
	props: {
		person: Object,
	},
	data() {
		return {
			loading: false,
		}
	},
	emits: ['reactivate', 'close'],
	methods: {
		async reactivateUser() {
			this.loading = true
			try {
				await patch(`/organization/users/${this.person.id}`, {
					active: true,
					send_welcome_message: true,
				})
				storage.set('org_mgmt_changed_people', true)
				this.$emit('reactivate', this.person.id)
				this.$alert.success(
					this.$t('admin_people_confirmation_person_reactivated_label')
				)
				this.close()
			} catch (e) {
				this.loading = false
				this.$refs.modal.$alert.error(e)
			}
		},
		close() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.reactivate-person-modal {
	.modal-wrapper {
		@include flex-column-center;
		max-width: 300px;
		margin: 24px auto;
		text-align: center;
		.pronto-icon {
			color: var(--blue-300);
			font-size: 50px;
			margin-bottom: 24px;
		}
	}
}
</style>
